import api from './api';

const quickBudgetService = {
  createBudget: async (budgetData) => {
    const response = await api.post('/quick-budgets', budgetData);
    return response.data;
  },

  listBudgets: async (params = {}) => {
    const response = await api.get('/quick-budgets', { params });
    return response.data;
  },

  getBudget: async (id) => {
    const response = await api.get(`/quick-budgets/${id}`);
    return response.data;
  },

  updateBudget: async (id, budgetData) => {
    const response = await api.put(`/quick-budgets/${id}`, budgetData);
    return response.data;
  },

  deleteBudget: async (id) => {
    const response = await api.delete(`/quick-budgets/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.patch(`/quick-budgets/${id}/status`, { status });
    return response.data;
  },

  convertToProject: async (id) => {
    const response = await api.post(`/quick-budgets/${id}/convert-to-project`);
    return response.data;
  },

  generatePDF: async (budgetId) => {
    const response = await api.post(`/quick-budgets/${budgetId}/generate-pdf`);
    return response.data;
  },

  previewPDF: async (budgetData) => {
    const response = await api.post('/quick-budgets/preview-pdf', budgetData);
    return response.data;
  },

  downloadPDF: async (budgetId, fileName) => {
    const response = await api.get(`/quick-budgets/${budgetId}/pdf?file=${fileName}`, {
      responseType: 'blob'
    });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/quick-budgets/stats');
    return response.data;
  },

  processPdf: async (formData) => {
    const response = await api.post('/cortes-pdf/process', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getPdfDetails: async (pdfId) => {
    const response = await api.get(`/cortes-pdf/${pdfId}`);
    return response.data;
  },

  matchPiecesWithStock: async (pieces) => {
    const response = await api.post('/quick-budgets/match-pieces', { pieces });
    return response.data;
  },

  createProductFromPiece: async (piece, productData) => {
    const response = await api.post('/quick-budgets/create-product', { piece, product_data: productData });
    return response.data;
  },

  getPricingConfig: async () => {
    const response = await api.get('/quick-budgets/pricing-config');
    return response.data;
  },

  calculatePrice: async (data) => {
    const response = await api.post('/quick-budgets/calculate-price', data);
    return response.data;
  },

  formatCurrency: (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  },

  formatDate: (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  },

  calculateItemTotal: (quantity, unitPrice) => {
    return (parseFloat(quantity) || 1) * (parseFloat(unitPrice) || 0);
  },

  calculateSubtotal: (items) => {
    if (!items || items.length === 0) return 0;
    return items.reduce((sum, item) => sum + quickBudgetService.calculateItemTotal(item.quantity, item.unit_price), 0);
  },

  calculateTotalWithDiscount: (subtotal, discountPercent) => {
    if (!discountPercent || discountPercent <= 0) return subtotal;
    return subtotal * (1 - (discountPercent || 0) / 100);
  },

  calculateParcel: (totalAmount, installments) => {
    if (!installments || installments <= 0) return totalAmount;
    return totalAmount / installments;
  },

  groupItemsByEnvironment: (items) => {
    if (!items || items.length === 0) return {};

    const groups = {};
    items.forEach(item => {
      const env = item.environment_name || 'Geral';
      if (!groups[env]) {
        groups[env] = [];
      }
      groups[env].push(item);
    });
    return groups;
  },

  calculateEnvironmentTotal: (items) => {
    if (!items || items.length === 0) return 0;
    return items.reduce((sum, item) => sum + quickBudgetService.calculateItemTotal(item.quantity, item.unit_price), 0);
  },

  getDefaultDiferenciais: () => {
    return [
      'MDF Ultra',
      'Dobradiças Blum',
      'Corrediças Invisíveis',
      'Garantia',
      'Projeto 3D'
    ];
  },

  getDefaultInclusoes: () => {
    return [
      'Projeto Executivo',
      'Medição',
      'Fabricação',
      'Transporte',
      'Montagem',
      'Garantia'
    ];
  },

  getDefaultNaoInclusoes: () => {
    return [
      'Elétrica',
      'Gesso',
      'Granito',
      'Pintura',
      'Hidráulica'
    ];
  }
};

export default quickBudgetService;
